import React from 'react';
import {FactCard} from '../../memory/FactCard';
import {ReviewEditor} from './ReviewCard';

/**
 * El modo "Lista completa" del acto Revisa.
 *
 * Es la MISMA fila de la cola de siempre (`FactCard` en modo `queue`), no una lista nueva que se le
 * parezca: la fila ya resuelve badges, procedencia colapsable, hint de duplicado y las tres
 * acciones, y cualquier arreglo que reciba ahí aparece también acá. La única pieza propia es el
 * editor, que es el mismo de la carta — un hecho se edita igual esté en el mazo o en la lista.
 *
 * Existe porque el mazo es un ritmo, no una obligación: quien tiene 40 pendientes y quiere barrer
 * de arriba abajo necesita verlos todos juntos. Las dos vistas leen la MISMA cola del store, así
 * que no pueden diferir en qué está pendiente.
 */
export function ReviewList({
    queue, documentsById, similarById, hintKindById, isBusy, editingId,
    onApprove, onReject, onEdit, onCancelEdit, onSaveEdit,
    // «Ver la cita» sobre la fuente. Va acá por la razón que dice el docstring: la lista monta la
    // MISMA `FactCard` que la cola, así que todo lo que la fila recibe tiene que llegarle también
    // por este camino. Faltó al cablear el visor y el resultado fue que el hecho que en el mazo
    // ofrecía «Ver la cita» no lo ofrecía en «Lista completa» — el trabajo que la card vino a
    // eliminar, intacto en uno de los dos modos del mismo acto (QA-cita-01b · review C-cita-05).
    onOpenSource,
}) {
    return (
        <div className="iabr-list">
            {queue.map(fact => (editingId === fact.id ? (
                <ReviewEditor key={fact.id} fact={fact} busy={isBusy(fact.id)} variant="row"
                              onSave={onSaveEdit} onCancel={onCancelEdit}/>
            ) : (
                <FactCard key={fact.id} fact={fact} mode="queue"
                          documentsById={documentsById}
                          busy={isBusy(fact.id)}
                          similar={(similarById || {})[fact.id]}
                          similarKind={(hintKindById || {})[fact.id]}
                          onApprove={onApprove}
                          onReject={onReject}
                          onEdit={onEdit}
                          onOpenSource={onOpenSource}/>
            )))}
        </div>
    );
}

export default ReviewList;
